import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getConfig, setConfig } from '../../configuracao/configLocal';
import { getConfControladorGrupoPluviometroList } from './selectdbAtions';

function normalizeContValue(value) {
  if (!value || value === '0' || value === 'todos') {
    return 0;
  }
  return value;
}

class SelectConfControladorPluviometroHistorico extends Component {
  constructor(props) {
    super(props);

    const initialValue = normalizeContValue(getConfig('cont'));
    if (getConfig('cont') === 'todos') {
      setConfig('cont', 0);
      setConfig('numCont', 0);
      setConfig('anel', 0);
    }

    this.state = {
      value: initialValue,
    };
  }

  componentDidMount() {
    this.props.getConfControladorGrupoPluviometroList();
  }

  componentDidUpdate(prevProps) {
    const grupo = getConfig('grupo');
    if (!grupo || grupo === '0') {
      if (+this.state.value !== 0) {
        setConfig('cont', 0);
        setConfig('numCont', 0);
        setConfig('anel', 0);
        this.setState({ value: 0 });
      }
      return;
    }

    if (prevProps.listPluviometro !== this.props.listPluviometro) {
      const currentValue = +this.state.value;
      if (currentValue !== 0) {
        const list = this.props.listPluviometro || [];
        const anel = this.props.anel !== false;
        const exists = list.some(cont => cont.id === currentValue && (anel || cont.anel === 1));
        if (!exists) {
          setConfig('cont', 0);
          setConfig('numCont', 0);
          setConfig('anel', 0);
          this.setState({ value: 0 });
        }
      }
    }
  }

  renderOptions() {
    const list = this.props.listPluviometro || [];
    const anel = this.props.anel !== false;

    if (list.length === 0) {
      return <option value="">Carregando...</option>;
    }

    const listCont = list.filter(cont => anel || cont.anel === 1);

    return listCont.map(contro => (
      <option
        key={contro.id}
        value={contro.id}
        data-numcont={contro.numero_controlador}
        data-anel={contro.anel}
        data-ip={contro.ip}
        data-porta={contro.porta}
      >
        {`${contro.numero_controlador} - ${contro.endereco}`}
        {anel && ` - Anel ${contro.anel}`}
      </option>
    ));
  }

  handleChange(event) {
    const newValue = event.target.value;

    if (+newValue === 0) {
      this.setState({ value: 0 });
      setConfig('cont', 0);
      setConfig('numCont', 0);
      setConfig('anel', 0);
      setConfig('ip', '');
      setConfig('porta', '');

      if (this.props.onChange) {
        this.props.onChange(0);
      }
      return;
    }

    const selectedOption = event.target.options[event.target.selectedIndex];
    const numCont = selectedOption.getAttribute('data-numcont');
    const anel = selectedOption.getAttribute('data-anel');
    const ip = selectedOption.getAttribute('data-ip');
    const porta = selectedOption.getAttribute('data-porta');

    this.setState({ value: newValue });
    setConfig('cont', newValue);
    setConfig('numCont', numCont);
    setConfig('anel', anel);
    setConfig('ip', ip);
    setConfig('porta', porta);

    if (this.props.onChange) {
      this.props.onChange(newValue);
    }
  }

  render() {
    const defaultStyle = { width: '300px', display: 'inline', marginLeft: '8px' };
    const finalStyle = this.props.customStyle ? this.props.customStyle : defaultStyle;

    return (
      <div style={{ marginTop: '0px' }}>
        <select
          id={'selectConfControlador'}
          name={'selectConfControlador'}
          style={finalStyle}
          className={this.props.customStyle ? '' : 'form-control'}
          onChange={event => {
            this.handleChange(event);
          }}
          value={this.state.value}
        >
          <option value="0">{this.props.emptyText || 'Selecione'}</option>
          {this.renderOptions()}
        </select>
      </div>
    );
  }
}

const mapStateToProps = state => ({ listPluviometro: state.selectdb.listControladorPluviometro });
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getConfControladorGrupoPluviometroList,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectConfControladorPluviometroHistorico);
